import Header from '@/components/common/Header'
import UserNav from '@/components/user-settings/UserNav'
import SelectLabelDashboard from '@/features/operations/components/pages/Dashboard/SelectLabelDashboard'
import { FC } from 'react'

interface ConfigHeaderProps {
  hideSelect?: boolean
  setupFirst?: boolean
}

const SetUpHeader: FC<ConfigHeaderProps> = ({ hideSelect, setupFirst }) => {
  return (
    <Header
      left={
        !hideSelect && (
          <SelectLabelDashboard isSetup width="322px" setupFirst={setupFirst} />
        )
      }
      right={<UserNav adminPage />}
      StackProps={{
        sx: {
          backgroundColor: 'rgba(217, 217, 217, 0.2)',
          borderBottom: 'none',
        },
      }}
      isSetupPage={true}
    />
  )
}

export default SetUpHeader
